(function ($) {
    function escapeHtml(text) {
        return String(text == null ? "" : text)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }

    function escapeAttr(text) {
        return escapeHtml(text);
    }

    function initCampanhasForm() {
        var $picker = $("#js-campanha-template-picker");
        if (!$picker.length) {
            return;
        }

        var $numeroSelect = $("#config_eloca_hyperflow_id");
        var $templateInput = $("#template_id");
        var $modal = $("#modal-campanha-template");
        var $btnAbrir = $(".js-campanha-template-abrir-modal");
        var $resumoNome = $(".js-campanha-template-resumo-nome");
        var $resumoHint = $(".js-campanha-template-resumo-hint");
        var $busca = $("#js-campanha-template-busca");
        var $lista = $("#js-campanha-template-lista");
        var urlTemplate = $picker.data("templates-url") || "";
        var selectedTemplateId = String($picker.data("selected-template-id") || "");
        var selectedTemplateName = String($picker.data("selected-template-name") || "");
        var searchTimeout = null;
        var currentNumeroId = null;
        var createTemplateUrl = "";
        var templatesCache = [];

        function updateResumo() {
            if ($templateInput.val() && selectedTemplateName) {
                $resumoNome.text(selectedTemplateName);
                $resumoHint.text("Template selecionado para esta campanha.");
                $btnAbrir.text("Alterar template");
                return;
            }

            $resumoNome.text("Nenhum template selecionado");
            $resumoHint.text("Selecione um número WhatsApp e escolha o template da campanha.");
            $btnAbrir.text("Escolher template");
        }

        function showPlaceholder(message) {
            $lista.html(
                '<p class="campanha-template-placeholder mb-0 js-campanha-template-placeholder">' +
                    escapeHtml(message) +
                    "</p>"
            );
        }

        function showLoading() {
            $lista.html(
                '<div class="text-center py-4 js-campanha-template-loading">' +
                    '<div class="spinner-border spinner-border-sm text-primary" role="status">' +
                    '<span class="sr-only">Carregando...</span>' +
                    "</div>" +
                    "</div>"
            );
        }

        function renderBadges(template) {
            var badges = [];

            if (template.tem_midia && !template.midia_preview_url) {
                badges.push(
                    '<span class="badge bg-info me-1"><i class="fas fa-image"></i> Mídia</span>'
                );
            }

            if (template.campos && template.campos.length) {
                template.campos.forEach(function (campo) {
                    badges.push(
                        '<span class="badge bg-secondary me-1">{{' +
                            escapeHtml(campo) +
                            "}}</span>"
                    );
                });
            }

            if (template.botoes && template.botoes.length) {
                template.botoes.forEach(function (botao) {
                    badges.push(
                        '<span class="badge bg-primary me-1"><i class="fas fa-hand-pointer"></i> ' +
                            escapeHtml(botao) +
                            "</span>"
                    );
                });
            }

            if (!badges.length) {
                return "";
            }

            return '<div class="campanha-template-card__badges">' + badges.join("") + "</div>";
        }

        function renderMidiaPreview(template) {
            if (template.midia_preview_url) {
                return (
                    '<div class="campanha-template-card__midia">' +
                    '<img src="' +
                    escapeAttr(template.midia_preview_url) +
                    '" alt="Prévia da mídia do template" width="40" height="40"' +
                    ' class="campanha-template-card__midia-img js-campanha-template-midia-img" loading="lazy">' +
                    "</div>"
                );
            }

            if (template.tem_midia) {
                return (
                    '<div class="campanha-template-card__midia campanha-template-card__midia--placeholder">' +
                    '<i class="fas fa-image" aria-hidden="true"></i>' +
                    '<span>Header com imagem</span>' +
                    "</div>"
                );
            }

            return "";
        }

        function renderCard(template) {
            var isActive =
                String(template.id) === String($templateInput.val() || selectedTemplateId);
            var activeClass = isActive ? " active" : "";
            var texto = template.template || "";
            var textoTruncado = texto.length > 200;
            var textoExibido = textoTruncado ? texto.substring(0, 200) + "…" : texto;

            return (
                '<div class="campanha-template-card js-campanha-template-card' +
                activeClass +
                '" data-template-id="' +
                template.id +
                '" data-template-name="' +
                escapeHtml(template.element_name) +
                '" role="button" tabindex="0">' +
                '<div class="campanha-template-card__layout">' +
                renderMidiaPreview(template) +
                '<div class="campanha-template-card__body">' +
                '<div class="d-flex w-100 justify-content-between align-items-start">' +
                '<h6 class="campanha-template-card__titulo mb-0">' +
                escapeHtml(template.element_name) +
                "</h6>" +
                (isActive
                    ? '<span class="badge bg-success ms-2">Selecionado</span>'
                    : "") +
                "</div>" +
                '<p class="campanha-template-card__texto js-campanha-template-texto' +
                (textoTruncado ? " text-truncate" : "") +
                '">' +
                escapeHtml(textoExibido) +
                "</p>" +
                (textoTruncado
                    ? '<span class="d-none js-campanha-template-texto-completo">' +
                      escapeHtml(texto) +
                      "</span>" +
                      '<button type="button" class="btn btn-link btn-sm campanha-template-card__expandir js-campanha-template-expandir">Ver mais</button>'
                    : "") +
                renderBadges(template) +
                "</div>" +
                "</div>" +
                "</div>"
            );
        }

        function renderLista(templates) {
            templatesCache = templates;

            if (!templates.length) {
                var linkHtml = createTemplateUrl
                    ? ' <a href="' +
                      escapeHtml(createTemplateUrl) +
                      '" target="_blank" rel="noopener">Criar template de campanha</a>'
                    : "";
                $lista.html(
                    '<p class="campanha-template-placeholder mb-0">Nenhum template de campanha aprovado para este número.' +
                        linkHtml +
                        "</p>"
                );
                return;
            }

            $lista.html(
                '<div class="campanha-template-cards">' +
                    templates.map(renderCard).join("") +
                    "</div>"
            );
        }

        function clearSelection() {
            $templateInput.val("");
            selectedTemplateId = "";
            selectedTemplateName = "";
            updateResumo();
        }

        function selectTemplate(templateId, templateName) {
            $templateInput.val(templateId);
            selectedTemplateId = String(templateId);
            selectedTemplateName = templateName || selectedTemplateName;
            updateResumo();

            $lista.find(".js-campanha-template-card").removeClass("active");
            $lista.find(".js-campanha-template-card .badge.bg-success").remove();

            var $card = $lista.find(
                '.js-campanha-template-card[data-template-id="' + templateId + '"]'
            );
            $card.addClass("active");
            $card.find(".d-flex").first().append(
                '<span class="badge bg-success ms-2">Selecionado</span>'
            );
        }

        function loadTemplates(numeroId, nome, callback) {
            if (!numeroId || !urlTemplate) {
                currentNumeroId = null;
                templatesCache = [];
                showPlaceholder(
                    "Selecione um número WhatsApp para ver os templates disponíveis."
                );
                if (typeof callback === "function") {
                    callback(false);
                }
                return;
            }

            currentNumeroId = numeroId;
            showLoading();

            var url = urlTemplate.replace("__ID__", numeroId);
            if (nome) {
                url += (url.indexOf("?") >= 0 ? "&" : "?") + "nome=" + encodeURIComponent(nome);
            }

            $.ajax({
                url: url,
                type: "GET",
                dataType: "json",
                headers: {
                    Accept: "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            })
                .done(function (response) {
                    createTemplateUrl = response.create_template_url || "";
                    var templates = response.templates || [];
                    renderLista(templates);

                    if (selectedTemplateId) {
                        var selected = templates.find(function (t) {
                            return String(t.id) === String(selectedTemplateId);
                        });
                        if (selected) {
                            selectTemplate(selected.id, selected.element_name);
                        } else if (!nome) {
                            clearSelection();
                        }
                    }

                    if (typeof callback === "function") {
                        callback(true);
                    }
                })
                .fail(function () {
                    templatesCache = [];
                    $lista.html(
                        '<p class="text-danger mb-0">Não foi possível carregar os templates.</p>'
                    );
                    if (typeof callback === "function") {
                        callback(false);
                    }
                });
        }

        function syncNumeroState() {
            var numeroId = $numeroSelect.val();
            if (numeroId) {
                $btnAbrir.prop("disabled", false);
                return;
            }

            $btnAbrir.prop("disabled", true);
            clearSelection();
        }

        $numeroSelect.on("change.campanhasForm", function () {
            var numeroId = $(this).val();
            $busca.val("");
            clearSelection();
            templatesCache = [];
            currentNumeroId = numeroId || null;
            syncNumeroState();
        });

        $btnAbrir.on("click.campanhasForm", function () {
            var numeroId = $numeroSelect.val();
            if (!numeroId) {
                showToastDanger("body", "Selecione um número WhatsApp antes de escolher o template.");
                return;
            }

            $busca.val("");
            $modal.modal("show");

            if (String(currentNumeroId) !== String(numeroId) || !templatesCache.length) {
                loadTemplates(numeroId, "");
                return;
            }

            renderLista(templatesCache);
            if (selectedTemplateId) {
                var selected = templatesCache.find(function (t) {
                    return String(t.id) === String(selectedTemplateId);
                });
                if (selected) {
                    selectTemplate(selected.id, selected.element_name);
                }
            }
        });

        $busca.on("input.campanhasForm", function () {
            if (!currentNumeroId) {
                return;
            }
            var termo = $(this).val();
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(function () {
                loadTemplates(currentNumeroId, termo);
            }, 300);
        });

        $lista.on("click.campanhasForm", ".js-campanha-template-card", function (e) {
            if ($(e.target).closest(".js-campanha-template-expandir").length) {
                return;
            }
            var templateId = $(this).data("template-id");
            var templateName = $(this).data("template-name") || "";
            selectTemplate(templateId, templateName);
            $modal.modal("hide");
        });

        $lista.on("keydown.campanhasForm", ".js-campanha-template-card", function (e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                var templateId = $(this).data("template-id");
                var templateName = $(this).data("template-name") || "";
                selectTemplate(templateId, templateName);
                $modal.modal("hide");
            }
        });

        $lista.on("error.campanhasForm", ".js-campanha-template-midia-img", function () {
            var $midia = $(this).closest(".campanha-template-card__midia");
            $midia
                .addClass("campanha-template-card__midia--placeholder")
                .html(
                    '<i class="fas fa-image" aria-hidden="true"></i><span>Prévia indisponível</span>'
                );
        });

        $lista.on("click.campanhasForm", ".js-campanha-template-expandir", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $card = $(this).closest(".js-campanha-template-card");
            var $texto = $card.find(".js-campanha-template-texto");
            var $completo = $card.find(".js-campanha-template-texto-completo");
            var isExpanded = $texto.hasClass("expanded");

            if (isExpanded) {
                var fullText = $completo.text();
                $texto
                    .removeClass("expanded")
                    .addClass("text-truncate")
                    .text(fullText.length > 200 ? fullText.substring(0, 200) + "…" : fullText);
                $(this).text("Ver mais");
            } else {
                $texto
                    .removeClass("text-truncate")
                    .addClass("expanded")
                    .text($completo.text());
                $(this).text("Ver menos");
            }
        });

        $picker.closest("form").on("submit.campanhasForm", function (e) {
            if (!$templateInput.val()) {
                e.preventDefault();
                $("#overlayer-loading").removeClass("show-overlayer");
                $("button", this).removeAttr("disabled");
                showToastDanger("body", "Selecione um template para a campanha.");
            }
        });

        syncNumeroState();
        updateResumo();

        if ($numeroSelect.val() && selectedTemplateId) {
            currentNumeroId = $numeroSelect.val();
        }
    }

    Eloca.behaviors.campanhasForm = initCampanhasForm;
})(jQuery);
